var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-custom-scrollbar",
    {
      directives: [
        {
          name: "scrollbar",
          rawName: "v-scrollbar",
          value: { isbuttom: _vm.isbuttom },
          expression: "{ isbuttom }"
        }
      ],
      staticClass: "scroll-area",
      attrs: { settings: _vm.settings },
      on: { "ps-scroll-y": _vm.scrollHanle, "ps-y-reach-end": _vm.scrollButtom }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d26b730", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d26b730","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ScrollbarMobile.vue
// module id = null
// module chunks = 